
















































import Vue from "vue";
import iwSkeletonBox from "@/shared/components/SkeletonBox.vue";

export default Vue.extend({
    name: "ClassifiedItemSkeleton",

    components: {
        iwSkeletonBox: iwSkeletonBox
    }
});
